var _a;
import { __decorate, __metadata, __param } from "tslib";
import { HeaderServiceManager } from '@/domains/header/header-service';
import _ from 'lodash';
import { provide, inject } from '@/inversify.config';
const cacheKey = 'TASK_ASSGIN_CUSTOM_FIELD_CACHE_';
export const TaskAssignCustomFieldCacheServiceSymbol = Symbol.for('TaskAssignCustomFieldCacheService');
let TaskAssignCustomFieldCacheService = class TaskAssignCustomFieldCacheService {
    constructor(headerServiceManager) {
        this.headerServiceManager = headerServiceManager;
        this.headerService = this.headerServiceManager.getHeaderServiceInstance();
    }
    setTaskLastUsedFields(fields) {
        return this.headerService.deferred.promise.then(() => {
            const key = cacheKey + this.headerService.account._info.account_id;
            localStorage.setItem(key, JSON.stringify(fields));
        });
    }
    getTaskLastUsedFields() {
        return this.headerService.deferred.promise.then(() => {
            const key = cacheKey + this.headerService.account._info.account_id;
            const fields = JSON.parse(localStorage.getItem(key));
            if (fields instanceof Array) {
                return fields;
            }
            throw new Error('Invalid cache data');
        });
    }
    handleInvalidCustomFieldId({ fields, ids, }) {
        return _.filter(ids, (field_id) => {
            return _.find(fields, { field_id });
        });
    }
};
TaskAssignCustomFieldCacheService = __decorate([
    provide(TaskAssignCustomFieldCacheServiceSymbol),
    __param(0, inject(HeaderServiceManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof HeaderServiceManager !== "undefined" && HeaderServiceManager) === "function" ? _a : Object])
], TaskAssignCustomFieldCacheService);
export { TaskAssignCustomFieldCacheService };
